import React, {useState, useEffect} from 'react'

/*eslint-disable */

import LogoProyecto from './logoProyecto.component'
import SelectionBtns from './selectionBtns.component'

import collapsed from './../../../UI/general/collapse.svg'

interface SelectionContainerProps {
    data: any,
    handleMenuSelection: any,
    selectionBtnName: string,
    isIngresoHidden: boolean
} 

const SelectionContainer = ({data, handleMenuSelection, selectionBtnName, isIngresoHidden}: SelectionContainerProps) => {

    const [isSelectionHidden, setSelectionHidden] = useState(true)

    useEffect(() => {
        if(isIngresoHidden){
            setTimeout(() => {
                setSelectionHidden(false)
            }, 400)
        }
    }, [isIngresoHidden])

    return(
        <React.Fragment>
            <div className={isSelectionHidden ? 'hide-selection-bar-container-collapsed':'hide-selection-bar-container'} onClick={() => {setSelectionHidden(!isSelectionHidden)}}>
                <img src={collapsed}/>
            </div>
            <div className={isSelectionHidden ? 'selection-bar-container-collapsed':'selection-bar-container'}>
                <LogoProyecto
                    logo={data.logo_proyecto}
                    handleMenuSelection = {handleMenuSelection}
                />
                <SelectionBtns
                    selectionData={data.menu_btns}
                    handleMenuSelection = {handleMenuSelection}
                    dataColors = {data.colors}
                    selectionBtnName = {selectionBtnName}
                />
            </div>
        </React.Fragment>
    )
}

export default SelectionContainer